import '@babel/polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import SherpaCrmApp from '@/components/SherpaCrmApp'
import { router } from '@/router/'
import store from '@/store'
import '@/language'
import vuewheel from 'vuewheel'
import DatePicker from 'vue2-datepicker'
import SpinnerLoading from 'vue-simple-spinner'
import VTooltip from 'v-tooltip'
import VuejsDialog from 'vuejs-dialog'
import VueMasonry from 'vue-masonry-css'

Vue.config.productionTip = false

// Load config from Webpack to Vue constant
Vue.config.sherpaCrm = process.env

// Create the event bus by creating a new Vue instance and
// binding it somehwere accessible. If you bind it to the
// Vue prototype, you can access it within your components
// like this:
//
// Emit an event
// this.$bus.$emit('myEvent', {data: true})
//
// React to an event
// this.$bus.$on('myEvent', (message) => {console.log(message})
// Vue.prototype.$bus = new Vue({})

Vue.use(vuewheel)
Vue.use(VTooltip)
Vue.use(VuejsDialog)
Vue.use(VueMasonry)

Vue.component('date-picker', DatePicker)
Vue.component('spinner-loading', SpinnerLoading)

/* eslint-disable no-new */
new Vue({
  el: 'sherpa-crm-app',
  router,
  store,
  components: {
    SherpaCrmApp
  },
  template: '<sherpa-crm-app/>'
})



// WEBPACK FOOTER //
// ./src/main.js